/**
 * HTML entity decoding utilities.
 */

/**
 * Decodes HTML entities in a string (e.g., &quot; to ")
 * 
 * @param text - Text containing HTML entities
 * @returns Decoded text
 */
export function decodeHtmlEntities(text: string): string {
  const textarea = document.createElement("textarea");
  textarea.innerHTML = text;
  return textarea.value;
}

